export default "__VITE_ASSET__CWUEnbXF__"